import { fromUnixTime } from "date-fns/esm";

import { formatDate } from "utils/date";

export const parseLicenseDate = (date?: number) => {
  if (!date) return undefined;

  try {
    return formatDate({
      date: fromUnixTime(date),
      format: "statusDate",
    });
  } catch {
    return undefined;
  }
};
